var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9C83624F-3766-4A62-8847-1BC63FA8E647@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coach-view",
    transform: "translate(-22.000000, -688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(22.000000, 688.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    opacity: 0.502637591,
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1196584,8.55914174 L7.63247909,8.55914174 L7.63247909,6.49076573 C7.73706942,5.26099309 8.76578814,4.31605158 10.0000003,4.31605158 C11.2342126,4.31605158 12.2629314,5.26099309 12.3675217,6.49076573 C12.3675217,6.86839632 12.6736518,7.1745264 13.0512824,7.1745264 C13.428913,7.1745264 13.735043,6.86839632 13.735043,6.49076573 C13.6020396,4.52586622 11.9693962,3 10.0000003,3 C8.03060454,3 6.39796121,4.52586622 6.26495775,6.49076573 L6.26495775,8.66170584 C5.50745202,8.92406482 4.99958,9.63783092 5.00000026,10.4394836 L5.00000026,15.4138424 C5.00000026,15.9125401 5.1981074,16.3908124 5.55073989,16.7434449 C5.90337239,17.0960774 6.38164469,17.2941843 6.88034235,17.2941843 L13.1196584,17.2941843 C14.1581425,17.2941843 15.0000003,16.4523265 15.0000003,15.4138424 L15.0000003,10.4394836 C15.0000003,9.40099946 14.1581425,8.55914174 13.1196584,8.55914174 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicLock);
export default __webpack_public_path__ + "static/media/publicLock.4d2d8221863e1085fb7ff11bdd35f2d8.svg";
export { ForwardRef as ReactComponent };